import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiChopin, API_CHOPIN } from '../config/index';
import { Observable } from 'rxjs';
import { SearchMetadata, SearchRequestParams, SearchResponse } from '@shared/interfaces/search.model';

@Injectable()
export class SearchService {
  constructor(
    @Inject(API_CHOPIN) private api: ApiChopin,
    private http: HttpClient
  ) {}

  search(params: SearchRequestParams): Observable<SearchResponse>{
    return this.http.get<SearchResponse>(this.api.SEARCH(), { params: params as any });
  }

  getSearchMetadata(): Observable<SearchMetadata>{
    return this.http.get<SearchMetadata>(this.api.SEARCH_METADATA())
  }

}
